import { render, staticRenderFns } from "./Inbound2.vue?vue&type=template&id=65a6cd6e&scoped=true&"
import script from "./Inbound2.vue?vue&type=script&lang=js&"
export * from "./Inbound2.vue?vue&type=script&lang=js&"
import style0 from "./Inbound2.vue?vue&type=style&index=0&id=65a6cd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6cd6e",
  null
  
)

export default component.exports